import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TrackerService } from '@shared/services/tracker.service';

/*
  Shown to the page that started a journey when the partner resumes it
  elsewhere: the bank came back in another tab (maybe another browser, on a
  phone), the partner reloaded the widget there and goes on with the
  connection. This page only says so — it never touches the connection: two
  widgets driving the same one would step on each other (accounts selected,
  analysis requested twice).
*/
@Component({
  selector: 'app-webauth-resumed-by-partner',
  templateUrl: './webauth-resumed-by-partner.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class WebauthResumedByPartnerComponent implements OnInit {
  constructor(private readonly tracker: TrackerService) {}

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'WEBAUTH_RESUMED_BY_PARTNER' });
  }
}
